module.exports = __webpack_public_path__ + "img/bazza-nava.cbfa25f2.png";